import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SiteFooter from '../components/SiteFooter';
import { HomeNav } from '../components/home/HomeNav';
import { HomeHero } from '../components/home/HomeHero';
import { IndustryFocus } from '../components/home/IndustryCatalog';
import { CommunicationMap } from '../components/home/OpsSections';
import { WorkflowCompare } from '../components/home/BeforeAfter';
import { IndustryTrust } from '../components/home/IndustryTrust';
import { AboutSection } from '../components/home/AboutSection';
import { MultiLocation } from '../components/home/MultiLocation';
import { LeadWorkspace } from '../components/home/ProductViews';
import { CustomerJourney } from '../components/home/JourneySection';
import { ProcessSection } from '../components/home/ProcessSection';
import { SystemsPricing } from '../components/home/SystemsPricing';
import { OpportunityEstimator } from '../components/home/OpportunityEstimator';
import { HomeFAQ, ContactSection } from '../components/home/FaqContact';
import { ServicesSection } from '../components/home/ServicesScenarios';
import { scrollToId } from '../components/home/homeData';

const useHashScroll = () => {
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 60);
    const t2 = setTimeout(() => scrollToId(hash.slice(1)), 700);
    return () => { clearTimeout(t); clearTimeout(t2); };
  }, [hash]);
};

export default function Home() {
  useHashScroll();
  return (
    <div className="landing-page yv-home">
      <a href="#main" className="yv-skip">Skip To Content</a>
      <HomeNav />
      <main id="main">
        <HomeHero />
        <ServicesSection />
        <IndustryFocus />
        <CommunicationMap />
        <CustomerJourney />
        <LeadWorkspace />
        <WorkflowCompare />
        <ProcessSection />
        <MultiLocation />
        <SystemsPricing />
        <OpportunityEstimator />
        <HomeFAQ />
        <AboutSection />
        <IndustryTrust />
        <ContactSection />
      </main>
      <SiteFooter />
    </div>
  );
}
